import { M_CheckBox, M_SwitchButton } from "../../../../M_Components"
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import "../item.css"

export const BooleanFieldItemForm = ({ field, changeValueCallback, itemForm, isDisabled }) => {
    const [t, i18n] = useTranslation();
    const currentLanguage = i18n.resolvedLanguage;

    // Ensure value is always a boolean, never a string
    const rawValue = itemForm.form[field.Code];
    let value;
    if (rawValue === null || rawValue === undefined) {
        value = field.DefaultValue !== null && field.DefaultValue !== undefined
            ? (typeof field.DefaultValue === 'boolean' ? field.DefaultValue : field.DefaultValue.toString().toLowerCase() === 'true')
            : false;
    } else if (typeof rawValue === 'string') {
        value = rawValue.toLowerCase() === 'true';
    } else {
        value = Boolean(rawValue);
    }

    // Initialize field with default value if not present in form
    useEffect(() => {
        if (rawValue === null || rawValue === undefined) {
            const defaultValue = field.DefaultValue !== null && field.DefaultValue !== undefined
                ? (typeof field.DefaultValue === 'boolean' ? field.DefaultValue : field.DefaultValue.toString().toLowerCase() === 'true')
                : false;
            changeValueCallback({
                ...itemForm,
                form: {
                    ...itemForm.form,
                    [field.Code]: defaultValue
                }
            });
        }
    }, [field.Code]); // Only run when field changes

    const handleInputChange = (checked) => {
        changeValueCallback({
            ...itemForm,
            form: {
                ...itemForm.form,
                [field.Code]: checked
            }
        });
    }

    return (
        <div className="boolean text">
            { field?.Style !== "Checkbox" &&
            <M_SwitchButton
                required={field.IsMandatory}
                label={field.Captions[currentLanguage]?.length > 0 ? field.Captions[currentLanguage] : field.Code}
                checked={value}
                disabled={isDisabled}
                onClick={(e) => handleInputChange(e.target.checked)}
            />
            }
            { field?.Style === "Checkbox" &&
            <M_CheckBox
                required={field.IsMandatory}
                label={field.Captions[currentLanguage]?.length > 0 ? field.Captions[currentLanguage] : field.Code}
                checked={value}
                disabled={isDisabled}
                onChange={(e) => handleInputChange(e.target.checked)}
            />
            }
        </div>
    )
}